import { DateTimeRange } from '../types';
import { getDateRangeString } from './getDateRangeString';
import { getDateRange } from './getDateRange';

export const getDateTimeRangeString = (timeRange: DateTimeRange) => {
  return getDateRangeString(getDateRange(timeRange));
};
